export interface UiState {
  readonly isAdding?: boolean;
  readonly isDeleting?: boolean;
  readonly isReordering?: boolean;
}
